import { connect } from 'react-redux';
import PersonLicenses from './PersonLicenses';
import {
    getPersonLicensesList,
    getPersonLicensesListLoadingStatus,
} from '../../../../store/selectors/person.selectors';
import {
    getLicenseTypesBegin,
    getMergeTemplatesBegin,
    mergeDocumentsBegin,
} from '../../../../store/actions/license.actions';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';
import { getMergeTemplatesList, getMergeTemplatesLoadingStatus } from 'src/store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const data = getPersonLicensesList(state);
    const mergeTemplatesList = getMergeTemplatesList(state);
    const loading = getPersonLicensesListLoadingStatus(state);
    const templateLoading = getMergeTemplatesLoadingStatus(state);
    return { data, loading, mergeTemplatesList, templateLoading };
};
const mapDispatchToProps = {
    getAuthenticationToken: getAuthenticationToken,
    getLicenseTypes: getLicenseTypesBegin,
    getMergeTemplatesBegin,
    mergeDocuments: mergeDocumentsBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(PersonLicenses);
